let FieldMessageType = /*#__PURE__*/function (FieldMessageType) {
  FieldMessageType["HINT"] = "hint";
  FieldMessageType["INFO"] = "info";
  FieldMessageType["ERROR"] = "error";
  FieldMessageType["SUCCESS"] = "success";
  return FieldMessageType;
}({});

export { FieldMessageType };
//# sourceMappingURL=messageType.js.map
